var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithubAlt2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13_572)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 99.95,
    cy: 99.95,
    r: 99.95,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.75 49.75C177.75 34.5 165.75 22.25 150.25 13.25C135 4.50001 118.25 0 100 0C81.75 0 65 4.5 49.75 13.5C34.5 22.25 22.5 34.5 13.5 49.75C4.5 65.25 0 81.75 0 100C0 121.75 6.25 141.5 19 158.75C31.75 176.25 48.25 188.25 68.25 195C70.5 195.5 72.25 195.25 73.5 194C74.75 193 75.25 191.75 75.25 190C75.25 189.75 75.25 187.5 75.25 183C75.25 178.5 75.25 174.75 75.25 171.5L72.25 172C70.25 172.25 68 172.5 65 172.5C62 172.5 59 172.25 56 171.5C52.75 171 50 169.75 47.25 167.5C44.5 165.5 42.75 162.75 41.5 159.5L40.25 156.5C39.5 154.5 38 152.25 36.25 149.75C34.5 147.25 32.5 145.75 30.5 144.75L29.5 144C29 143.5 28.25 143 27.75 142.5C27.25 142 26.75 141.25 26.5 140.75C26.25 140.25 26.5 139.75 27.25 139.25C28 138.75 29.25 138.75 31 138.75L33.5 139.25C35.25 139.5 37.5 140.75 40 142.25C42.5 144 44.75 146.25 46.25 149C48.25 152.5 50.75 155.25 53.5 157.25C56.25 159 59.25 160 62 160C64.75 160 67.25 159.75 69.5 159.25C71.5 158.75 73.5 158.25 75.25 157.25C76 151.5 78.25 147 81.75 143.75C76.75 143.25 72.25 142.5 68.5 141.5C64.5 140.5 60.5 138.75 56.25 136.5C52 134.25 48.5 131.25 45.75 127.75C43 124.25 40.75 119.75 39 114C37.25 108.25 36.25 101.75 36.25 94.5C36.25 84 39.75 75 46.5 67.75C43.25 59.75 43.5 51 47.5 41.25C50 40.5 53.75 41 58.75 43C63.75 45 67.25 46.75 69.5 48C71.75 49.5 73.75 50.5 75 51.5C83 49.25 91.5 48 100 48C108.5 48 117 49.25 125 51.5L130 48.5C133.5 46.5 137.5 44.5 142 42.75C146.5 41 150 40.5 152.5 41.25C156.5 51 156.75 60 153.5 67.75C160.25 75.25 163.75 84 163.75 94.5C163.75 102 162.75 108.5 161 114C159.25 119.75 157 124.25 154 127.75C151.25 131.25 147.75 134 143.5 136.5C139.25 138.75 135.25 140.5 131.25 141.5C127.25 142.5 122.75 143.25 118 143.75C122.5 147.75 124.75 153.75 124.75 162.25V189.75C124.75 191.25 125.25 192.5 126.5 193.75C127.5 194.75 129.25 195 131.75 194.75C152 188 168.25 176 181 158.5C193.75 141 200 121.5 200 99.75C200 81.75 195.5 65.25 186.75 49.75Z",
    fill: "#302839"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93 118.5C94.1667 120.333 97.2 124 100 124C103.5 124 106.5 122 107.5 119",
    stroke: "#302839",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137,
    cy: 92.5,
    rx: 14,
    ry: 20.5,
    fill: "#302839"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 137,
    cy: 92.5,
    rx: 9,
    ry: 13.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 92.5,
    rx: 14,
    ry: 20.5,
    fill: "#302839"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 62,
    cy: 92.5,
    rx: 9,
    ry: 13.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100.5,
    cy: 110.5,
    r: 3.5,
    fill: "#302839"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13_572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubAlt2);
export default __webpack_public_path__ + "static/media/github-alt2.547c44b724bf266e3ef0364328d22ccd.svg";
export { ForwardRef as ReactComponent };